import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled
} from '@mui/material';
import { dateFormatter, getReccurssiveObjectKeys } from '../../../../../../utils';
import { Checkbox } from '../../../../../../components';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.9),
  whiteSpace: 'nowrap',
  fontSize: '13px'
}));

export const FinalBillTable = ({
  data,
  columns,
  onRowClick,
  containerSX,
  sx,
  showInputField,
  handleInputChange,
  showOk,
  handleRowSelect,
  isSelected,
  selectedRows,
  activeSelection,
  selectedRow
}) => {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    console.log(activeSelection, 'ACTIVEVEVEVEVV');
    console.log(data, 'HELLO DATA');
    const filteredData = data?.filter((item) => item.type === activeSelection);
    const mapFilteredData = filteredData?.map((item) => ({
      ...item,
      _id: item?._id ? item._id : item.service
    }));
    setFilteredData(mapFilteredData);
  }, [activeSelection, data]);

  console.log(filteredData, 'FILRSHXJSHJ');

  return (
    <TableContainer sx={{ maxHeight: '259px', overflowY: 'auto', ...containerSX }}>
      <MuiTable sx={sx}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'lightblue' }}>
            {showOk && (
              <StyledTableCell key="ok-cell" sx={{ fontWeight: 'bold' }}>
                Edit
              </StyledTableCell>
            )}
            <StyledTableCell key="sr.no.-cell" sx={{ fontWeight: 'bold' }}>
              Sr. No.
            </StyledTableCell>
            {columns.map((column, index) => (
              <StyledTableCell sx={{ fontWeight: 'bold' }} key={`header-cell-${index}`}>
                {column.header}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((row, rowIndex) => (
            <TableRow
              {...(onRowClick && {
                onClick: () => {
                  onRowClick(row);
                }
              })}
              sx={{
                backgroundColor: rowIndex % 2 ? 'grey.200' : 'none',
                cursor: onRowClick ? 'pointer' : 'default',
                '&:hover': {
                  backgroundColor: 'grey.300'
                },
                transition: 'all 0.1s ease-in',
                backgroundColor: isSelected(row, 'ok') ? 'lightgreen' : 'none', // Highlight if selected
                '&:hover': { backgroundColor: 'grey.300' } // Hover effect
              }}
              key={rowIndex}
            >
              {showOk && (
                <StyledTableCell>
                  <Checkbox
                    sx={{
                      transform: 'scale(0.8)',
                      padding: '0'
                    }}
                    name={row?._id}
                    disabled={selectedRow}
                    checked={isSelected(row, 'ok')}
                    onChange={() => handleRowSelect(row, 'ok')}
                  />
                </StyledTableCell>
              )}
              <StyledTableCell key={`${row._id}-cell0`}>{rowIndex + 1}</StyledTableCell>
              {columns.map(({ header, accessor, sx }, colIndex) => (
                <StyledTableCell sx={sx} key={`${row._id}-cell${colIndex + 1}`}>
                  {activeSelection !== 'room charge' && header === 'quantity' && showInputField ? (
                    <TextField
                      name="quantity"
                      type="number"
                      inputProps={{
                        min: 1 // Ensures the input can't be lower than 1
                      }}
                      value={row?.[header] || ''}
                      onChange={(e) => handleInputChange(e, row._id, header)}
                      onBlur={(e) => {
                        // Check if the value is less than or equal to 0, and set it to 1
                        if (Number(e.target.value) <= 0) {
                          handleInputChange({ target: { value: '1' } }, row._id, header);
                        }
                      }}
                      disabled={!selectedRows.some((selectedRow) => selectedRow._id === row._id)}
                      variant="outlined"
                      size="small"
                      sx={{
                        width: '60px',
                        '& .MuiOutlinedInput-input': {
                          padding: '4px 8px'
                        },
                        '& .MuiInputBase-root': {
                          padding: '0px'
                        }
                      }}
                    />
                  ) : activeSelection !== 'room charge' && header === 'rate' && showInputField ? (
                    <TextField
                      name="rate"
                      value={row?.[header] || ''}
                      onChange={(e) => {
                        handleInputChange(e, row._id, header); // Continue with the input change if valid
                      }}
                      disabled={!selectedRows.some((selectedRow) => selectedRow._id === row._id)}
                      variant="outlined"
                      size="small"
                      type="number"
                      sx={{
                        width: '60px',
                        '& .MuiOutlinedInput-input': {
                          padding: '4px 8px'
                        },
                        '& .MuiInputBase-root': {
                          padding: '0px'
                        }
                      }}
                    />
                  ) : header === 'disc_amt' && showInputField ? (
                    <TextField
                      name="disc_amt"
                      value={row?.[header] || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Check if the value is a number and not greater than 100
                        if (value && (parseFloat(value) > row?.['amount'] || isNaN(value))) {
                          return; // Prevent updating if the value exceeds 100 or is invalid
                        }
                        handleInputChange(e, row._id, header); // Continue with the input change if valid
                      }}
                      disabled={!selectedRows.some((selectedRow) => selectedRow._id === row._id)}
                      variant="outlined"
                      size="small"
                      type="number"
                      sx={{
                        width: '60px',
                        '& .MuiOutlinedInput-input': {
                          padding: '4px 8px'
                        },
                        '& .MuiInputBase-root': {
                          padding: '0px'
                        }
                      }}
                    />
                  ) : typeof accessor === 'function' ? (
                    accessor(row) || '0'
                  ) : (
                    <>
                      {header === 'Created At' || header === 'Date'
                        ? dateFormatter(getReccurssiveObjectKeys(row, accessor)) || '-'
                        : getReccurssiveObjectKeys(row, accessor) || '0'}
                    </>
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
